require("bijou/base");
require("bijou/toggle_transition");

function changeComparisonPaymentPreference() {
  const $monthly = $(
    ".payment-preference-toggle-enabled .payment-preference--monthly",
  );
  const $annual = $(
    ".payment-preference-toggle-enabled .payment-preference--annual",
  );

  if ($("#payment-preference-toggle").prop("checked") === true) {
    $monthly.hide();
    $annual.show();
    updateComparisonPaymentPreference("annual");
  } else if ($("#payment-preference-toggle").prop("checked") === false) {
    $annual.hide();
    $monthly.show();
    updateComparisonPaymentPreference("monthly");
  }
}

function updateComparisonPaymentPreference(toggleState) {
  $.ajax({
    type: "POST",
    url: `${location.pathname}?step_action=toggle_payment_preference`,
    data: { payment_preference: toggleState },
    dataType: "json",
  });
}

function toggleProviderInformation(providerId, showDetails) {
  const provider = document.getElementById(providerId);
  const $providerLogo = $(
    `.js-insurer-logo-form[data-button-id='${provider.id}']`,
  );
  const $providerDetails = $(
    `.provider-information-details[data-button-id='${provider.id}']`,
  );

  if (showDetails) {
    $(provider).hide();
    $providerLogo.hide();
    $providerDetails.show();
    publishProviderInformationDisplayedEvent(provider.dataset.insurerName);
  } else {
    $(provider).show();
    $providerLogo.show();
    $providerDetails.hide();
  }
}

function togglePaymentInformation(providerId, showDetails) {
  const provider = $(
    `.payment-information-button[data-button-id=${providerId}]`,
  );
  const providerPaymentDetails = $(
    `.payment-information-details[data-button-id=${providerId}]`,
  );
  const insurer = $(`#${providerId}`).data("insurerName");

  if (showDetails) {
    $(provider).hide();
    $(providerPaymentDetails).show();
    publishPaymentInformationExpandedEvent(insurer);
  } else {
    $(provider).show();
    $(providerPaymentDetails).hide();
  }
}

function publishPaymentInformationExpandedEvent(insurerName) {
  $.ajax({
    type: "POST",
    url: `${location.pathname}?step_action=publish_payment_information_expanded_event`,
    data: { insurer_name: insurerName },
    dataType: "json",
  });
}

function publishProviderInformationDisplayedEvent(insurerName) {
  $.ajax({
    type: "POST",
    url: `${location.pathname}?step_action=publish_provider_information_displayed_event`,
    data: { insurer_name: insurerName },
    dataType: "json",
  });
}

(function () {
  /*
  == Description

  This widget handles cover toggling on the comparison page.

  === Behaviour

  - Applies cover_toggle widget to all cover toggles (dropdowns and checkboxes)
  - Requests new quotes from the server when covers are changed
  - Toggles a 'please wait' overlay during server requests (effectively disabling
    cover toggles until new quotes are retrieved)
  - Pushes a new history state when new quotes are retrieved (for browsers with
    history support) and restores previous quotes when user navigates back and
    forward. The widget also handles navigating back to history states without
    a cached state (requests quote search from server instead).

  == Tracking

  - Sends all click events on links to Snowplow
  - Triggers 'comparison_page_cover_changed' events each time a cover is changed

  == Deprecation

  As part of moving to the journey framework we're moving, component by component,
  the various pages that make the conversion journey. We had to change the code
  in this file to be backwards compatible with what we call the CI5 code. This
  code will be removed at a later date. For the time being we need to support
  both approaches.

  - The @options.deprecated code looks for a data attribute provided on the DOM.
    It's only present on the CI5 view. Since this is not present in the journey
    view code it's safe use this as a "feature flag".
   */

  $.widget("chopin.quote_comparison", $.bijou.base, {
    _create() {
      this.storage = {};
      this.overlay = this.element.find(".js-please-wait-overlay");
      this.decisionContainer = this.element.find(".js-decision-container");
      this.helpSection = this.element.find(".js-help-section");
      this.quotesHintSection = this.element.find(".js-quotes-hint-section");
      this.personalisationSection = this.element.find(
        ".js-personalisation-section",
      );
      this.togglableCoversSection = this.element.find(
        ".js-togglable-covers-section",
      );
      this.noQuotesBoxSection = this.element.find(".js-no-quotes-box-section");
      this.overlay.attr("aria-hidden", "true");
      this.overlay.attr("aria-labelledby", "toggle-cover-update-message");
      if (this.options.deprecated) {
        this.updateEndpoint = "/create";
      } else {
        this.updateEndpoint = "?step_action=change_cover";
      }
      this.coverToggles = this.element
        .find(".js-cover-toggling-item")
        .cover_toggle();
      this._save(this.element.find(".js-quote-or-referral").data("slug"));
      this._on({
        cover_togglechange(e, data) {
          return this._update(data);
        },
        "click a": function ({ currentTarget, target }) {
          const _ref = window.snowplowHelper;
          return _ref != null
            ? _ref.trackLinkClick({
                targetUrl: $(currentTarget).attr("href"),
                elementContent:
                  $(target).attr("alt") || $(currentTarget).text(),
              })
            : undefined;
        },
        "change #payment-preference-toggle": changeComparisonPaymentPreference,
        "click .provider-information": function (event) {
          toggleProviderInformation(event.currentTarget.id, true);
        },
        "click .provider-information-details.close-button": function (event) {
          toggleProviderInformation(event.currentTarget.id, false);
        },
        "click .monthly-payment-information:not(.close)": function (event) {
          togglePaymentInformation(event.currentTarget.id, true);
        },
        "click .monthly-payment-information.close": function (event) {
          togglePaymentInformation(event.currentTarget.id, false);
        },
      });

      return this._on(this.window, {
        popstate() {
          return this._restore(window.location.pathname.split("/").pop());
        },
      });
    },
    _save(reference) {
      this.storage[reference] = {
        quoteOrReferral: this.decisionContainer.html(),
        coverValues: this.coverToggles.map(function () {
          return $(this).cover_toggle("value");
        }),
      };
      return this.storage[reference];
    },
    _restore(reference) {
      const snapshot = this.storage[reference];
      if (snapshot) {
        this.decisionContainer.html(snapshot.quoteOrReferral);
        this.coverToggles.each(function (index, coverToggle) {
          return $(coverToggle).cover_toggle(
            "update",
            snapshot.coverValues[index],
          );
        });
        return EventTracker.trigger("comparison_page_cover_changed", {
          name: "history",
          action: "back",
        });
      }
      return this;
    },
    _getCoverValue(element) {
      if (element.is(":checkbox") && !element.prop("checked")) {
        return 0;
      }
      return element.val();
    },
    _update(data) {
      this.overlay.toggleTransition(function () {
        return $(this).addClass("overlay--active");
      });
      this.overlay.attr({
        "aria-hidden": "false",
        "aria-live": "assertive",
      });
      const req = $.ajax({
        url: window.location.pathname + this.updateEndpoint,
        type: "POST",
        data: {
          cover_name: data.elementId,
          cover_value: data.newValue,
          journey_token: this.element.data("journey-token"),
        },
        context: this,
        dataType: "json",
      });
      req.done(function (response) {
        const _ref = window.history;
        this.decisionContainer.html(response.quote_or_referral);
        if (response.success) {
          if ($(".cover-toggling__warning #qa-togging-error").length > 0) {
            $(".cover-toggling__warning #qa-togging-error").remove();
          }
          this.helpSection.html(response.help_section_message);
          this.quotesHintSection.html(response.quotes_number_hint_view_model);
          this.personalisationSection.html(
            response.personalisation_section_view_model,
          );
          this.togglableCoversSection.html(response.togglable_covers_section);
          this.noQuotesBoxSection.html(response.no_quote_box_view_model);
          this.coverToggles = this.togglableCoversSection
            .find(".js-cover-toggling-item")
            .cover_toggle();
        } else {
          window.location.href = response.redirection_url;
        }
        this.element.data("journey-token", response.new_journey_token);
        $.bijou.enhance(this.decisionContainer);
        if (!this.options.deprecated) {
          return undefined;
        }
        const reference = this.decisionContainer
          .find(".js-quote-or-referral")
          .data("slug");
        const referenceInUrl = reference;
        if (_ref != null) {
          if (typeof _ref.pushState === "function") {
            _ref.pushState(null, null, referenceInUrl);
          }
        }
        return this._save(reference);
      });
      req.fail(function (jqXHR) {
        let ajaxErrorMessage;
        const errorCode = jqXHR.status;
        if (errorCode === 400) {
          ajaxErrorMessage = `It looks like you might have our site open in multiple tabs or windows,
            or experienced a network connection problem. You can continue your
            purchase in the other window, or refresh this page.`;
        } else {
          ajaxErrorMessage = "Failed to toggle cover options.";
        }
        $(".cover-toggling__warning #qa-togging-error").remove();
        return $(
          `<p id="qa-togging-error" class="warning--toggling-error" role="alert" aria-atomic="true">
            <span>
              ${ajaxErrorMessage}
            </span>
          </p>`,
        ).prependTo($(".cover-toggling__warning"));
      });
      req.always(function () {
        this.overlay.attr("aria-hidden", "true");
        this.overlay.removeAttr("aria-live");
        if ($("#payment-preference-toggle").prop("checked") === undefined) {
          $(".payment-preference-toggle-enabled").hide();
        } else {
          $(".payment-preference-toggle-disabled").hide();
        }
        return this.overlay.toggleTransition(function () {
          return $(this).removeClass("overlay--active");
        });
      });
      return EventTracker.trigger("comparison_page_cover_changed", {
        name: data.coverLabel,
        from_value: data.oldValue,
        to_value: data.newValue,
      });
    },
  });

  $.widget("chopin.cover_toggle", $.bijou.base, {
    _create() {
      this.inputElement = this.element.find(":input");
      this.coverLabel = $.trim(this.element.find(".js-label").text());
      this.type = this.inputElement.is(":checkbox") ? "checkbox" : "select";
      this.currentValue = this.value();
      if (this.type === "select") {
        this.displayElement = this.element.find(".js-cover-display");
      }
      return this._on(this.inputElement, {
        change: this._onChange,
      });
    },
    update(newValue) {
      if (this.type === "checkbox") {
        this.inputElement.prop("checked", newValue === this.inputElement.val());
      } else {
        this.inputElement.val(newValue);
        this._updateDisplay();
      }
      this.currentValue = this.value();
      return this.currentValue;
    },
    value() {
      let inputElementValue;
      if (this.type === "checkbox" && !this.inputElement.prop("checked")) {
        inputElementValue = this.inputElement.val();
        switch (false) {
          case inputElementValue !== "yes":
            return "no";
          case inputElementValue !== "I need this cover":
            return "I don't need this cover";
          case inputElementValue !== "Include":
            return "Not required";
          default:
            return "0";
        }
      } else {
        return this.inputElement.val();
      }
    },
    _onChange(evt) {
      const newValue = this.value();
      this._trigger("change", evt, {
        elementId: this.inputElement.attr("id"),
        coverLabel: this.coverLabel,
        oldValue: this.currentValue,
        newValue,
      });
      this.currentValue = newValue;

      return this.currentValue;
    },
    _updateDisplay() {
      return this.displayElement.text(
        this.inputElement
          .find("option")
          .eq(this.inputElement.prop("selectedIndex"))
          .text(),
      );
    },
  });
}).call(this);
